<template>
  <div class="detail-navigation">
    <a-button type="primary" style="margin-right: 8px;" ghost @click="prevDetail"> 
      <a-icon type="left" />上一张
    </a-button>
    <a-button type="primary" style="margin-right: 8px;" ghost @click="nextDetail"> 
      <a-icon type="right" />下一张
    </a-button>
  </div>
</template>

<script>
export default {
  name: 'DetailNavigation',
  props: {
    // 当前记录的ID
    currentId: {
      type: [String, Number],
      required: true
    },
    // 获取上一条记录ID的方法
    getPrevId: {
      type: Function,
      required: true
    },
    // 获取下一条记录ID的方法
    getNextId: {
      type: Function,
      required: true
    },
    // 导航到新ID的回调函数
    onNavigate: {
      type: Function,
      required: true
    }
  },
  methods: {
    prevDetail() {
      this.getPrevId(this.currentId).then(prevId => {
        if (prevId) {
          this.onNavigate(prevId);
        } else {
          this.$message.warning('已经是第一条记录');
        }
      }).catch(err => {
        this.$message.error('获取上一条记录失败');
        console.error(err);
      });
    },
    nextDetail() {
      this.getNextId(this.currentId).then(nextId => {
        if (nextId) {
          this.onNavigate(nextId);
        } else {
          this.$message.warning('已经是最后一条记录');
        }
      }).catch(err => {
        this.$message.error('获取下一条记录失败');
        console.error(err);
      });
    }
  }
}
</script>

<style scoped>
.detail-navigation {
  display: inline-block;
}
</style>